<div class="login-container">

  <div class="login-branding-panel">
    <div class="branding-blob branding-blob-1"></div>
    <div class="branding-blob branding-blob-2"></div>
    <div class="branding-blob branding-blob-3"></div>
    <div class="branding-grid"></div>
    <div class="branding-content">
      <div class="branding-logo-row fade-in-up" style="--delay: 0s">
        <img src="assets/logo/spark-icon-transparent.png" alt="" class="branding-logo">
        <span class="branding-logo-text">Spark</span>
      </div>
      <h2 class="branding-title fade-in-up" style="--delay: 0.08s">Talk to your documents, instantly.</h2>
      <p class="branding-subtitle fade-in-up" style="--delay: 0.16s">Spark turns your project's knowledge base into a conversation - ask a question, get a grounded answer.</p>

      <ul class="branding-features fade-in-up" style="--delay: 0.24s">
        <li>
          <span class="branding-feature-icon">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M2.5 6.2L4.8 8.5L9.5 3.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </span>
          Instant, grounded answers from your own documents
        </li>
        <li>
          <span class="branding-feature-icon">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M2.5 6.2L4.8 8.5L9.5 3.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </span>
          Secure, tenant-isolated access to your knowledge base
        </li>
        <li>
          <span class="branding-feature-icon">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M2.5 6.2L4.8 8.5L9.5 3.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </span>
          Insights, clusters and visualizations, built in
        </li>
      </ul>
    </div>
  </div>

  <div class="login-form-panel">
    <div class="background-gradient">
      <img src="assets/images/background-gradient.svg" alt="Background Gradient" class="gradient-image">
    </div>

    <div class="login-card">
      <div class="login-logo-section">
        <img src="assets/logo/spark-horizontal-transparent.png" alt="Spark Logo" class="login-logo">
      </div>

      <div class="header-section">
        <h1 class="app-title">Welcome back</h1>
        <p class="app-description">Sign in to chat with your project's documents</p>
      </div>
      
      <form class="login-form" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
         <app-input-field
           label="Email"
           type="email"
           placeholder="Enter email"
           icon="assets/icons/person-icon.svg"
           [required]="true"
           [hasError]="emailHasError"
           [errorMessage]="emailError"
           [value]="loginForm.get('email')?.value || ''"
           (valueChange)="onEmailChange($event)"
           (clearError)="onEmailErrorClear()">
         </app-input-field>
         
         <app-input-field
           label="Password"
           type="password"
           placeholder="Enter password"
           icon="assets/icons/password-lock-icon.svg"
           [showPasswordToggle]="true"
           [required]="true"
           [hasError]="passwordHasError"
           [errorMessage]="passwordError"
           [value]="loginForm.get('password')?.value || ''"
           (valueChange)="onPasswordChange($event)"
           (clearError)="onPasswordErrorClear()">
         </app-input-field>

        <div class="forgot-password-row">
          <button type="button" class="forgot-password-button" (click)="openForgotPasswordModal()">Forgot password?</button>
        </div>
        
        <button type="submit" class="login-button" [disabled]="isLoading">
          <span *ngIf="!isLoading">Login</span>
          <span *ngIf="isLoading" class="spinner"></span>
        </button>
      </form>

      <p class="login-footnote">Protected by enterprise-grade security &amp; encryption</p>
      
    </div>
  </div>
</div>
